/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandalonePagination as ResolvedStandalonePagination } from 'base/components/standalone/Pagination';

export const Pagination: typeof ResolvedStandalonePagination = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandalonePagination {...props} />
    );
});

export type PaginationProps = PropsFromComponent<typeof Pagination>;

/** @deprecated Use slot architecture instead */
export const PaginationWith = (extras: DynamicStandaloneExtras): typeof Pagination => {
    return function Pagination(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Pagination');
        return <ResolvedStandalonePagination {...mergeProps({ options: { theme } }, props)} />;
    }
}